module.exports = __webpack_public_path__ + "img/woo-icon.7f4f44ed.png";